module.exports = __webpack_public_path__ + "portal-static/img/text.b5ab5d96.png";